var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{style:(_vm.baseStyle)},_vm._l((_vm.message.messages),function(msg){return _c('span',[_vm._v(_vm._s(msg))])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }